import { Box, Button, Text } from '@chakra-ui/react'
import { faRocketLaunch } from '@fortawesome/pro-duotone-svg-icons'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import RPC from '@/client/rpc'

import { useToaster } from '@/components/Toast/useToaster'
import Icon from '@/components/UI/Icon/Icon'

// NOTE: This component is rendered behind a condition. Request all query data from parent
export default function BackgroundCheckInitiate({
  countryCode,
  onInitiated,
}: {
  countryCode: string
  onInitiated: () => void
}) {
  const toast = useToaster()

  const [handleClick, inProgress] = useAPIWrapper(
    async () => {
      await RPC.requestBackgroundCheck({})
      toast({
        title: 'Initiated the Background Check. Keep an eye on your mailbox',
        status: 'success',
      })

      onInitiated()
    },
    [onInitiated, toast],
    'Submit Background check'
  )

  return (
    <Box>
      <Text mb={4} color="red.fg">
        Before initiating the check, please make sure that the country listed in your profile (code:{' '}
        {countryCode}) is accurate.
      </Text>
      <Button
        isDisabled={inProgress}
        onClick={handleClick}
        rightIcon={<Icon size="md" faIcon={faRocketLaunch} />}
      >
        Initiate Background Check
      </Button>
    </Box>
  )
}
